/**
 * The player's server setting: the address typed on the sign-in screen (or on the loading screen's server form),
 * kept in the app storage. Offered where a player may need another server than the build's: the native app (the
 * emulator's 10.0.2.2, a LAN IP, a self-hosted server), the Vite dev server, or a web build made with
 * VITE_FWP_SERVER_SETTING=1. The production web page keeps talking only to its own origin and ignores a stored value.
 */
import type { WebStorageLike } from '../../server/core/storage-local';
import { normalizeServerAddress } from '../config';

/** App storage key of the address ('' / absent = the build's default server). */
export const SERVER_SETTING_KEY = 'fwp.server';

export function readServerSetting(storage: WebStorageLike): string {
  try {
    return (storage.getItem(SERVER_SETTING_KEY) ?? '').trim();
  } catch {
    return '';
  }
}

/**
 * Stores a valid address ('' removes the setting: back to the default); returns false for an invalid one (with
 * `secureOnly`, also for one without TLS: normalizeServerAddress).
 */
export function writeServerSetting(storage: WebStorageLike, address: string, opts: { secureOnly?: boolean } = {}): boolean {
  const a = address.trim();
  if (a !== '' && !normalizeServerAddress(a, opts).ok) return false;
  try {
    if (a === '') storage.removeItem(SERVER_SETTING_KEY);
    else storage.setItem(SERVER_SETTING_KEY, a);
    return true;
  } catch {
    return false;
  }
}
